module.exports = __webpack_public_path__ + "static/media/Tischset_45x35_4erSet.89a316a5.png";